var _style, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoc = function SvgDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "doc_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".doc_svg__st3{fill:#172d72}")), /*#__PURE__*/React.createElement("g", {
    id: "doc_svg__\\u7EC4_5974",
    transform: "translate(-243.383 -132.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "doc_svg__\\u7EC4_5968",
    transform: "translate(243.383 132.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "doc_svg__\\u77E9\\u5F62_5293",
    style: {
      fill: "none"
    },
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "doc_svg__\\u7EC4_5970",
    transform: "translate(253.456 140.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "doc_svg__\\u7EC4_5969",
    transform: "translate(3.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "doc_svg__\\u8DEF\\u5F84_17293",
    d: "M28 8v26.9H0V0h19.9L28 8z",
    style: {
      fill: "#be1d32"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "doc_svg__\\u8DEF\\u5F84_17294",
    d: "M36 24v16H0V16h28l8 8z",
    style: {
      fill: "#e2e5ee"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "doc_svg__\\u77E9\\u5F62_5294",
    className: "doc_svg__st3",
    d: "M6 20h16v4H6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "doc_svg__\\u692D\\u5706_1334",
    className: "doc_svg__st3",
    cx: 8,
    cy: 30,
    r: 2
  })))));
};
export default SvgDoc;